/* ==========================================================================
   Select > Prototype
   ========================================================================== */

/* Modules */
const { addToStore, removeFromStore } = require('@bluekiri/alexandria/helpers/store');
const Choices = require('choices.js');

/* Select store */
let store = [];

const prototype = {
    /* Display */
    show: function Fn() {
        this.element.classList.remove(this.config.css.hidden);

        return this;
    },

    /* Hide */
    hide: function Fn() {
        this.element.classList.add(this.config.css.hidden);

        return this;
    },

    /* Has error */
    hasError: function Fn() {
        return this.error;
    },

    /* Has Choices selected */
    hasChoicesMultiple: function Fn() {
        /* Check if choices list have it a choices items */
        if (this.choices.containerInner.type === 'select-multiple') return true;

        return false;
    },

    /* Set choicesMultiple */
    setChoicesMultiple: function Fn() {
        const choicesListEl = this.choices.itemList.element;

        /* Check if choices list have it a choices items */
        if (choicesListEl.hasChildNodes()) return this.element.classList.add(this.config.css.hasChoices);

        this.element.classList.remove(this.config.css.hasChoices);
    },

    /* Set valid */
    setValid: function Fn() {
        this.element.classList.remove(this.config.css.error);
        this.element.classList.add(this.config.css.valid);

        /* Set validation to state */
        this.error = false;

        return this;
    },

    /* Set error */
    setError: function Fn() {
        this.element.classList.remove(this.config.css.valid);
        this.element.classList.add(this.config.css.error);

        /* Set error to state */
        this.error = true;

        return this;
    },

    /* Reset status */
    resetStatus: function Fn() {
        this.element.classList.remove(this.config.css.valid);
        this.element.classList.remove(this.config.css.error);

        /* Reset validation to state */
        this.error = false;

        return this;
    },

    /* Pairing label */
    setPairing: function Fn() {
        if (this.element.querySelector('label')) {
            this.getSelect().setAttribute('id', this.id);
            this.getLabel().setAttribute('for', this.id);
        }

        return this;
    },

    /* Get input */
    getSelect: function Fn() {
        return this.element.querySelector('select');
    },

    /* Get label */
    getLabel: function Fn() {
        return this.element.querySelector('label');
    },

    /* Get value */
    get: function Fn(valueOnly = false) {
        return this.choices.getValue(valueOnly);
    },

    /* Set value */
    set: function Fn(value = '') {
        this.choices.setChoiceByValue(value);

        /* Add reference in the instance */
        this.value = this.get(true);

        return this;
    },

    /* Set choices */
    /* eslint-disable */
    setChoices: function Fn(items = [], value = 'value', label = 'label', replace = false) {
        /* eslint-enable */

        /* Control no empty data */
        if (items.length < 1) return this;

        /* Update data reference */
        if (replace) {
            this.data = items;
        } else {
            items.forEach(item => this.data.push(item));
        }

        this.choices.setChoices(items, value, label, replace);

        return this;
    },

    /* On change */
    onChange: function Fn() {
        /* Update value reference */
        this.value = this.get(true);

        /* Check if choices list have it a choices items */
        if (this.hasChoicesMultiple()) this.setChoicesMultiple();

        /* Check callback from config passing this */
        if (this.config.onChange.length > 0) this.config.onChange.forEach(item => item(this));

        return this;
    },

    /* On click */
    onClick: function Fn(event) {
        /* Call internal library method to display in case we are inside panels */
        this.choices.showDropdown();

        /* Prevent bubbling */
        event.stopPropagation();

        return this;
    },

    /* On open */
    onOpen: function Fn() {
        /* Force hide all selects except the opened one */
        this.getStore()
            .filter(item => item !== this)
            .forEach(item => item.choices.hideDropdown());

        /* Invoke callback */
        if (typeof this.config.onOpen === 'function') this.config.onOpen.call(this, this);
    },

    /* Bind events */
    bindEvents: function Fn() {
        /* On change */
        this.onChange = this.onChange.bind(this);

        /* On click */
        this.onClick = this.onClick.bind(this);

        /* On open */
        this.onOpen = this.onOpen.bind(this);

        return this;
    },

    /* Add event listener */
    addEventListener: function Fn() {
        /* Bind events */
        this.bindEvents();

        /* On Change */
        this.getSelect().addEventListener('change', this.onChange);

        /* On Open */
        this.getSelect().addEventListener('showDropdown', this.onOpen);

        /* On Click */
        if (this.config.enableClick) this.element.addEventListener('click', this.onClick);

        return this;
    },

    /* Remove event listener */
    removeEventListener: function Fn() {
        /* On Change */
        this.getSelect().removeEventListener('change', this.onChange);

        /* On Open */
        this.getSelect().removeEventListener('showDropdown', this.onOpen);

        /* On Click */
        if (this.config.enableClick) this.element.removeEventListener('click', this.onClick);

        return this;
    },

    /* Add to store */
    addToStore: function Fn() {
        /* Control unique instances of same modal */
        if (this.getStore().filter(item => item.type !== this.type).length > 0) return this;

        /* Quarry function */
        addToStore(this, store);

        return this;
    },

    /* Remove from store */
    removeFromStore: function Fn() {
        store = removeFromStore(this, store);

        return this;
    },

    /* Get store */
    getStore: function Fn() {
        return store;
    },

    /* Setup choices */
    setupChoices() {
        if (this.choices) return this;

        /* Create 3rd party library choices instance */
        this.choices = new Choices(this.getSelect(), this.config.choices);

        return this;
    },

    /* Init */
    init: function Fn() {
        /* Set Pairing */
        this.setPairing();

        /* isMultiple */
        this.isMultiple = this.element.dataset.ismultiple === 'true';

        /* Setup choices */
        this.setupChoices();

        /* Add listeners */
        if (this.config.domEvents) this.addEventListener();

        /* Check if choices list have it a choices items */
        this.setChoicesMultiple();

        /* Add to store */
        if (this.config.autoStore) this.addToStore();

        /* Clean dataset */
        this.element.dataset.items = '';

        /* Update value */
        this.value = this.get(true);
    }
};

module.exports = prototype;
